// extracted by mini-css-extract-plugin
module.exports = {"Checkbox":"Checkbox--2hSU7","Unchecked":"Unchecked--33ojH","Checked":"Checked--3bMDn"};